import { render, staticRenderFns } from "./RDModal.vue?vue&type=template&id=6f77d524&scoped=true"
import script from "./RDModal.vue?vue&type=script&lang=js"
export * from "./RDModal.vue?vue&type=script&lang=js"
import style0 from "./RDModal.vue?vue&type=style&index=0&id=6f77d524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77d524",
  null
  
)

export default component.exports